import { render, staticRenderFns } from "./Semaforo.vue?vue&type=template&id=3f8743c6&"
import script from "./Semaforo.vue?vue&type=script&lang=js&"
export * from "./Semaforo.vue?vue&type=script&lang=js&"
import style0 from "./Semaforo.vue?vue&type=style&index=0&id=3f8743c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports